import { render, staticRenderFns } from "./TextContentMetadata.vue?vue&type=template&id=1a5cc0ba"
import script from "./TextContentMetadata.vue?vue&type=script&lang=js"
export * from "./TextContentMetadata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports